import axios from "axios";
import qs from "qs";


const instance = axios.create({
  baseURL: 'https://www.yixilife.com/admin',
  timeout: '60000',
  headers: {
    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
  },
});

instance.interceptors.request.use(
  (config) => {
    if (config.data) {
      config.data = qs.stringify(config.data);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default instance;



// WEBPACK FOOTER //
// ./src/utils/request.js